import { render, staticRenderFns } from "./DreieckGS.vue?vue&type=template&id=a6e5e270&"
import script from "./DreieckGS.vue?vue&type=script&lang=js&"
export * from "./DreieckGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports